import React, { useEffect, useState } from "react";
import { usePost } from "seed/api";
import { ColumnTypes } from "components/collections/util/datatypes";
import { FileField } from "seed/helpers";
import l from "components/util/l";

const DefaultField = ({
  idx,
  field,
  values,
  setFieldValue,
}) => {

  const [collectionValues, setCollectionValues] = useState([]);

  const [callGetData] = usePost("/collections/get_data", {
    onCompleted: (data) => {
      setCollectionValues(data.data);
    }
  });

  const refetchData = () =>
    callGetData({
      collection_id: field?.final.structure.collection_id,
      page_size: 50,
      page_number: 1,
      ignore_compress: true
    });

  const setDefaultValue = (value) => {
    setFieldValue("structure", values?.structure?.map((f, j) => {
      if (j == idx) return {
        ...f,
        final: {
          ...f.final,
          default_value: value
        }
      };
      return f;
    }));
  };

  useEffect(() => {
    if (field.final.type == ColumnTypes.COLLECTION && field.final?.structure?.collection_id)
      refetchData();
  }, [field]);

  return <div className="w-100">

    {
      field.final.type == ColumnTypes.STRING &&
      <input
        type="text"
        className="form-control form-control-sm"
        value={field.final.default_value}
        onChange={(e) => setDefaultValue(e.target.value)}
      />
    }

    {
      field.final.type == ColumnTypes.FLOAT &&
      <input
        type="number"
        className="form-control form-control-sm"
        value={field.final.default_value}
        onChange={(e) => setDefaultValue(e.target.value)}
      />
    }

    {
      field.final.type == ColumnTypes.FILE &&
      <FileField
        setFieldValue={() => { }}
        onCompleted={(file) => setDefaultValue(file)}
      />
    }

    {
      field.final.type == ColumnTypes.DATE &&
      <input
        type="date"
        className="form-control form-control-sm"
        value={field.final.default_value}
        onChange={(e) => setDefaultValue(e.target.value)}
      />
    }

    {
      field.final.type == ColumnTypes.TIME &&
      <input
        type="time"
        className="form-control form-control-sm"
        value={field.final.default_value}
        onChange={(e) => setDefaultValue(e.target.value)}
      />
    }

    {
      field.final.type == ColumnTypes.DATE_TIME &&
      <input
        type="datetime-local"
        className="form-control form-control-sm"
        value={field.final.default_value}
        onChange={(e) => setDefaultValue(e.target.value)}
      />
    }

    {
      field.final.type == ColumnTypes.ENUM &&
      <select
        className="form-control form-control-sm"
        value={field.final.default_value}
        onChange={(e) => setDefaultValue(e.target.value)}
      >
        <option value="">{l("Seleccionar%GA083")}...</option>
        {field.final.structure.values.map((option, index) => (
          <option key={index} value={option.value}>
            {option.value}
          </option>
        ))}
      </select>
    }

    {
      field.final.type == ColumnTypes.COLLECTION &&
      <select
        className="form-control form-control-sm"
        value={field.final.default_value}
        onChange={(e) => setDefaultValue(e.target.value)}
      >
        <option value="">{l("Seleccionar%GA083")}...</option>
        {
          collectionValues.map((option, index) => (
            <option key={index} value={option.pk_label}>
              {option.pk_label}
            </option>
          ))
        }
      </select>
    }

    {
      field.final.type == ColumnTypes.BOOLEAN &&
      <select
        className="form-control form-control-sm"
        value={field.final.default_value}
        onChange={(e) => {
          if (e.target.value)
            setDefaultValue(e.target.value == "true")
          else
            setDefaultValue(null)
        }}
      >
        <option value="">{l("Seleccionar%GA083")}...</option>
        <option value="false">{l("No%GA099")}</option>
        <option value="true">{l("Sí%GA098")}</option>
      </select>
    }

    {
      field.final.type == ColumnTypes.USER &&
      <select
        className="form-control form-control-sm"
        value={field.final.default_value}
        onChange={(e) => setDefaultValue({ id: sessionStorage.getItem("id") })}
      >
        <option value="">{l("Seleccionar%GA083")}...</option>
        <option value="&user">{l("Yo%CA154")}</option>
      </select>
    }

    {
      field.final.type == ColumnTypes.LOCATION &&
      <button
        type="button"
        className={`btn btn-sm ${field.final.default_value?.lat ? "btn-primary" : "btn-outline-secondary"}`}
        onClick={() => {

          if (!navigator.geolocation) {
            return;
          }

          navigator.geolocation.getCurrentPosition(
            (position) => {
              const coords = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              setDefaultValue(coords);
            }
          );

        }}
      >
        {l(field.final.default_value?.lat ? "Ubicación guardada%CA156" : "Utilizar mi ubicación%CA155")}
      </button>

    }

  </div>;

}

export default DefaultField;